import ArticleController from './article-controller'

export default ArticleController
